import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { GlobalMessageType } from '@spartacus/core';
import { AuthService, GlobalMessageService, RoutingService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { KbUpdateProfileService } from 'src/app/services/feature/update-profile/kb-update-profile.service';

@Component({
  selector: 'app-confirm-close-acc-popup',
  templateUrl: './confirm-close-acc-popup.component.html',
  styleUrls: ['./confirm-close-acc-popup.component.scss'],
  standalone: false
})
export class ConfirmCloseAccPopupComponent {
  isMobile: boolean = false;
  sub = new Subscription();
  constructor(public breakpointObserver: BreakpointObserver,
    private closeAccService: KbUpdateProfileService,
    private authService: AuthService,
    private routingService: RoutingService,
  ) {
    this.sub.add(this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
      }));
  }
  closeAcc() {
    this.sub.add(this.closeAccService.closeAccApi().subscribe((res: any) => {
      this.authService.coreLogout();
      this.closeAccService.accClosed.next(true);
      this.routingService.go({ cxRoute: 'home' });
    }))
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
